import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { GeocodingTaskInfo } from '../models/GeocodingTaskInfo';
import { GetGeocodingTasksRequest } from '../requests/GeocodingBackgrounderRequests';

class GeocodingTasksResource implements IListResource<GeocodingTaskInfo> {
  private listFetcher = new WebClientListResourceFetcher(GetGeocodingTasksRequest, ServerApiMapper.geocodingTasks);

  public all(): ResourceQuery<GeocodingTaskInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const GeocodingTasks = new GeocodingTasksResource();
